import React, { createContext, useState } from "react";

const IntervaloDataContext = createContext();

function competenciaMesAnterior() {
  const data = new Date();
  data.setDate(1);
  data.setMonth(data.getMonth() - 1);

  return `${String(data.getMonth() + 1).padStart(2, "0")}/${data.getFullYear()}`;
}

function IntervaloDataContextProvider({ children }) {
  const competenciaPadrao = competenciaMesAnterior();
  const [dataInicio, setDataInicio] = useState(() => {
    const valueDateI = new Date();
    valueDateI.setDate(valueDateI.getDate() - 10);
    return valueDateI;
  });
  const [dataFim, setDataFim] = useState(new Date());

  const [competencia, setCompetencia] = useState("");
  const [competenciaInicial, setCompetenciaInicial] =
    useState(competenciaPadrao);
  const [competenciaFinal, setCompetenciaFinal] =
    useState(competenciaPadrao);
  const [notaFiscal, setNotaFiscal] = useState("");

  return (
    <IntervaloDataContext.Provider
      value={{
        dataInicio,
        setDataInicio,
        dataFim,
        setDataFim,
        competencia,
        setCompetencia,
        competenciaPadrao,
        competenciaInicial,
        setCompetenciaInicial,
        competenciaFinal,
        setCompetenciaFinal,
        setNotaFiscal,
        notaFiscal,
      }}
    >
      {children}
    </IntervaloDataContext.Provider>
  );
}

export { IntervaloDataContext, IntervaloDataContextProvider };
